import React, { Component } from "react";
import CartContext from "./CartContext";
import { SideMenu } from "./SideMenu";
import { BiRefresh } from "react-icons/bi";
import { BsFillPencilFill } from "react-icons/bs";
import { MessageBox } from "./MessageBox";
import { LoadSpinner } from "./LoadSpinner";
import Fuse from "fuse.js";
import { Country, State, City } from "country-state-city";

import {
  OverlayTrigger,
  Tooltip,
  Button,
  ButtonToolbar,
  Form,
  Stack,
  FormControl,
  Row,
  Col,
  Modal,
  Nav,
  Table,
  Navbar,
} from "react-bootstrap";

export class ProductServiceCustomers extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      productservicecustomers: [],
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      reload: true,
      firstload: false,
      searchData: [],
      searchquery: "",
    };
  }
  onSearchChange = (query) => {
    this.setState({ reload: false });
    this.setState({ searchquery: query });
    if (!query) {
      this.setState({ searchData: this.state.productservicecustomers }, () => {
        this.setState({ reload: true });
      });
      return;
    }
    const fuse = new Fuse(this.state.searchData, {
      keys: ["firstName", "lastName", "mobileNo"],
      threshold: 0.6,
      ignoreLocation: true,
      findAllMatches: true,
      includeMatches: true,
      distance: 120,
    });
    const result = fuse.search(query);
    const finalResult = [];
    if (result.length) {
      result.forEach((item) => {
        finalResult.push(item.item);
      });
      this.setState({ searchData: finalResult.slice(0, 15) }, () => {
        this.setState({ reload: true });
      });
    } else {
      this.setState({ searchData: [] });
    }
  };
  GetProductServiceCustomers = () => {
    fetch(
      process.env.REACT_APP_API +
        "ProductService/GetProductServiceCustomers/" +
        this.context.storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          this.setState({ productservicecustomers: data }, () => {
            this.setState({ searchData: data });
            this.setState({ reload: false }, () => {
              this.setState({ reload: true });
            });
          });
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
  };

  OnSaved = () => {
    this.OnRefreshButtonClick();
  };
  OnDeleted = () => {
    this.OnRefreshButtonClick();
  };

  OnRefreshButtonClick = () => {
    this.setState({ productservicecustomers: [] }, () => {
      this.GetProductServiceCustomers();
    });
  };
  ShowMessagBox = (title, message) => {
    this.setState({ msgboxOpen: true });
    this.setState({ msgboxTitle: title });
    this.setState({ msgboxMessage: message });
  };

  OnUpdated = (indexno) => {
    this.OnRefreshButtonClick();
  };

  addModalClose = (e) => {
    this.setState({ addModalShow: false }, () => {});
    this.OnRefreshButtonClick();
  };

  componentDidMount = () => {
    if (this.state.firstload == false) {
      this.state.firstload = true;
      this.GetProductServiceCustomers();
    }
    window.scrollTo(0, 0);
  };

  render() {
    return (
      <>
        <div className="Container-fluid p-1">
          {this.state.msgboxOpen === true ? (
            <MessageBox
              open={this.state.msgboxOpen}
              title={this.state.msgboxTitle}
              message={this.state.msgboxMessage}
              callback={this.CloseMessagBoxCallback}
            />
          ) : (
            ""
          )}
          <Navbar className="shadow position-sticky fixed-top py-3 text-black ">
            <h3>
              <b>Customers</b> &nbsp;
            </h3>
            <Navbar.Collapse className="justify-content-end mx-0 ">
              <Nav>
                <ButtonToolbar className="text-end align-middle">
                  <Button
                    className="mainthemecolor"
                    size="sm"
                    onClick={() => this.setState({ addModalShow: true })}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="26"
                      height="26"
                      fill="currentColor"
                      class="bi bi-plus"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                    </svg>
                    Add
                  </Button>
                  &nbsp;
                  <Button
                    className="mainthemecolor"
                    size="sm"
                    onClick={() => this.OnRefreshButtonClick()}
                  >
                    <BiRefresh size="26"></BiRefresh>
                    Refresh
                  </Button>
                  &nbsp;
                  {this.state.addModalShow === true ? (
                    <ProductServiceCustomerAddOrEditModal
                      show={this.state.addModalShow}
                      Type="Add"
                      onHide={this.addModalClose}
                    />
                  ) : null}
                </ButtonToolbar>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
          <div className="py-3">
            <Table className="pt-0 m-0" size="sm">
              <Row className="">
                <Col>
                  <Stack direction="horizontal" gap={3} className="">
                    <b>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="30"
                        fill="currentColor"
                        class="bi bi-search"
                        viewBox="0 0 16 16"
                      >
                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                      </svg>
                    </b>
                    <FormControl
                      type="search"
                      placeholder="Search... "
                      className="text-primary fw-bold bg-white "
                      size="lg"
                      aria-label="Search"
                      onChange={(e) => this.onSearchChange(e.target.value)}
                    />
                  </Stack>
                </Col>
              </Row>
            </Table>
          </div>
          <div>
            <Table border striped className="px-0 bg-white ">
              <thead className="">
                <tr className="text-start text-black bg-white border">
                  <th width="5%"></th>
                  <th width="20%">Name</th>
                  <th width="10%">MobileNo</th>
                  <th width="15%">Email-Id</th>
                  <th width="25%">Address</th>
                  <th width="20%" className="text-end">
                    Options
                  </th>
                </tr>
              </thead>
              <tbody className="text-primary border">
                {/* {this.state.productservicecustomers */}
                {this.state.searchData
                  .sort((a, b) => (a.created > b.created ? 1 : -1))
                  .map((productservicecustomer, i) =>
                    this.state.reload === true ? (
                      <EditProductServiceCustomerInline
                        index={i}
                        productservicecustomer={productservicecustomer}
                        OnDeleted={this.OnDeleted}
                      ></EditProductServiceCustomerInline>
                    ) : null
                  )}
              </tbody>
            </Table>
          </div>
        </div>
      </>
    );
  }
}

export class EditProductServiceCustomerInline extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      productservicecustomer: "",
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      loadSpinnerOpen: false,
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      editModalShow: false,
    };
  }

  ShowMessagBox = (title, message) => {
    this.setState({ msgboxOpen: true });
    this.setState({ msgboxTitle: title });
    this.setState({ msgboxMessage: message });
  };
  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
  };

  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };
  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
  };

  OnDelete = () => {
    if (this.state.productservicecustomer.id == undefined) {
      this.ShowMessagBox(
        "Information",
        "This is invalid row which can't be deleted. Press Refresh!"
      );
      return;
    }

    this.ShowLoadSpinner();
    const requestOptions = {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    };

    fetch(
      process.env.REACT_APP_API +
        "ProductService/DeleteProductServiceCustomer/" +
        this.state.productservicecustomer.id,
      requestOptions
    )
      .then((res) => {
        if (res.status != 200) {
          this.HideLoadSpinner();
          alert(
            "Not deleted. This ProductServiceCustomer may be associated with few Products. First disassociate this productservicecustomer from the Products and then try!"
          );
          return;
        }
        this.HideLoadSpinner();
        this.ShowMessagBox(
          "Status",
          "Deleted Successfully. Click Refresh Button to see the changes!"
        );
        this.props.OnDeleted();
      })
      .catch((error) => {
        this.HideLoadSpinner();
        alert("OnDelete Failed" + error);
      });
  };

  componentDidMount = () => {
    this.setState({
      productservicecustomer: this.props.productservicecustomer,
    });
  };
  OnEditButtonClick = () => {
    this.setState({ editModalShow: true }, () => {});
  };

  editModalClose = () => {
    this.setState({ editModalShow: false }, () => {});
  };

  render() {
    return (
      <>
        {this.state.editModalShow === true ? (
          <ProductServiceCustomerAddOrEditModal
            show={this.state.editModalShow}
            onHide={this.editModalClose}
            productservicecustomer={this.state.productservicecustomer}
            Type="Edit"
          />
        ) : (
          ""
        )}
        {this.state.loadSpinnerOpen === true ? (
          <LoadSpinner open="true"></LoadSpinner>
        ) : (
          ""
        )}
        <tr
          className="text-start align-middle text-secondary bg-white mx-5"
          style={{ fontSize: "12px" }}
        >
          {this.state.msgboxOpen === true ? (
            <MessageBox
              open={this.state.msgboxOpen}
              title={this.state.msgboxTitle}
              message={this.state.msgboxMessage}
              callback={this.CloseMessagBoxCallback}
            />
          ) : (
            ""
          )}
          <td>{this.props.index + 1}</td>
          <td className="text-start ">
            {this.state.productservicecustomer.firstName}
          </td>
          <td className="text-start ">
            {this.state.productservicecustomer.mobileNo}
          </td>
          <td className="text-start ">
            {this.state.productservicecustomer.emailId}
          </td>
          <td className="text-start ">
            {this.state.productservicecustomer.address +
              ", " +
              this.state.productservicecustomer.city +
              ", " +
              this.state.productservicecustomer.state +
              ", " +
              this.state.productservicecustomer.country +
              ", " +
              this.state.productservicecustomer.pinCode}
          </td>
          <td className="col-md-2 text-end align-middle ">
            <div class="btn-group">
              <OverlayTrigger overlay={<Tooltip>Edit!</Tooltip>}>
                <Button
                  variant="warning"
                  size="sm"
                  onClick={(e) => {
                    this.OnEditButtonClick(e);
                  }}
                >
                  <BsFillPencilFill size="16" />
                </Button>
              </OverlayTrigger>

              <OverlayTrigger
                overlay={
                  <Tooltip>
                    Warning! This will delete this Brand Row and associated
                    Products as well.
                  </Tooltip>
                }
              >
                <Button
                  className="mx-1 "
                  size="sm"
                  variant="danger"
                  onClick={(e) => {
                    if (
                      window.confirm(
                        "Warning! This action will delete this Brand Row and associated Products as well. Are you sure you want to Delete?"
                      )
                    ) {
                      this.OnDelete(e);
                    }
                  }}
                >
                  X
                </Button>
              </OverlayTrigger>
            </div>
          </td>
        </tr>
      </>
    );
  }
}

export class ProductServiceCustomerAddOrEditModal extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);

    this.state = {
      productservicecustomer: { country: "", state: "" },
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      loadSpinnerOpen: false,
    };
  }

  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
    this.props.onHide();
  };
  ShowMessagBox = (title, message) => {
    this.setState({ msgboxOpen: true });
    this.setState({ msgboxTitle: title });
    this.setState({ msgboxMessage: message });
  };
  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };

  AddOrUpdateProductServiceCustomerInDB = () => {
    this.ShowLoadSpinner();

    var tmpProductServiceCustomer = this.state.productservicecustomer;
    if (this.props.Type == "Edit") {
      tmpProductServiceCustomer = this.props.productservicecustomer;
    } else {
      tmpProductServiceCustomer.storeId = this.context.storeId;
    }
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(tmpProductServiceCustomer),
    };

    fetch(
      process.env.REACT_APP_API +
        "ProductService/AddOrUpdateProductServiceCustomerAccount/",
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
          this.HideLoadSpinner();
          alert("user already exist!");
        } else {
          this.HideLoadSpinner();
          this.props.onHide(data);
        }
      })
      .catch((error) => {
        this.HideLoadSpinner();
        alert("Exception. Received an Exception. Try after sometime !" + error);
      });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.AddOrUpdateProductServiceCustomerInDB();
    event.stopPropagation();
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;

    switch (name.trim()) {
      case "firstName":
        this.state.productservicecustomer.firstName = value;
        break;
      case "lastName":
        this.state.productservicecustomer.lastName = value;
        break;
      case "mobileNo":
        this.state.productservicecustomer.mobileNo = value;
        break;
      case "emailId":
        this.state.productservicecustomer.emailId = value;
        break;
      case "address":
        this.state.productservicecustomer.address = value;
        break;
      case "city":
        this.state.productservicecustomer.city = value;
        break;
      case "state":
        this.state.productservicecustomer.state = value;
        break;
      case "country":
        this.state.productservicecustomer.country = value;
        break;
      case "pinCode":
        this.state.productservicecustomer.pinCode = value;
        break;
    }
    this.setState({
      productservicecustomer: this.state.productservicecustomer,
    });
  };

  componentDidMount() {
    if (this.props.Type == "Edit") {
      this.setState({
        productservicecustomer: this.props.productservicecustomer,
      });
    }
  }

  render() {
    return (
      <div className="container ">
        <Modal
          {...this.props}
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static"
          keyboard={false}
          dialogClassName="ProductServiceCustomerModal"
        >
          {this.state.msgboxOpen === true ? (
            <MessageBox
              open={this.state.msgboxOpen}
              title={this.state.msgboxTitle}
              message={this.state.msgboxMessage}
              callback={this.CloseMessagBoxCallback}
            />
          ) : (
            ""
          )}
          {this.state.loadSpinnerOpen === true ? (
            <LoadSpinner open="true"></LoadSpinner>
          ) : (
            ""
          )}
          <Form onSubmit={this.handleSubmit}>
            <Modal.Header closeButton className="bg-warning">
              <Modal.Title id="contained-modal-title-vcenter">
                {this.props.Type == "Edit" ? "Edit Customer" : "Add Customer"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="show-grid ">
              <Row
                className="m-2 p-2 bg-light border"
                style={{ fontSize: "12pt" }}
              >
                <Col md={12}>
                  <Form.Group as={Row} className="mb-3 " controlId="">
                    <Form.Label column sm="3">
                      Mobile No (*)
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="number"
                        name="mobileNo"
                        maxlength="10"
                        required
                        value={this.state.productservicecustomer.mobileNo}
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3 " controlId="">
                    <Form.Label column sm="3">
                      First Name (*)
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="text"
                        name="firstName"
                        maxlength="99"
                        value={this.state.productservicecustomer.firstName}
                        required
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3 " controlId="">
                    <Form.Label column sm="3">
                      Last Name
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="text"
                        name="lastName"
                        maxlength="99"
                        value={this.state.productservicecustomer.lastName}
                        required
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} className="mb-3 " controlId="">
                    <Form.Label column sm="3">
                      EmailId
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="email"
                        name="emailId"
                        maxlength="99"
                        value={this.state.productservicecustomer.emailId}
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3 " controlId="">
                    <Form.Label column sm="3">
                      Address (*)
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="text"
                        name="address"
                        required
                        maxlength="99"
                        value={this.state.productservicecustomer.address}
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3 " controlId="">
                    <Form.Label column sm="3">
                      City (*)
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="text"
                        name="city"
                        required
                        maxlength="99"
                        value={this.state.productservicecustomer.city}
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} className="mb-3 " controlId="">
                    <Form.Label column sm="3">
                      Country (*)
                    </Form.Label>
                    <Col sm="9">
                      <Form.Select
                        type="text"
                        name="country"
                        value={this.state.productservicecustomer.country}
                        required
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      >
                        <option value=""></option>
                        {Country.getAllCountries().map((country) => (
                          <>
                            <option value={country.isoCode}>
                              {country.name}
                            </option>
                          </>
                        ))}
                      </Form.Select>
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3 " controlId="">
                    <Form.Label column sm="3">
                      State (*)
                    </Form.Label>
                    <Col sm="9">
                      <Form.Select
                        type="text"
                        name="state"
                        value={this.state.productservicecustomer.state}
                        required
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      >
                        <option value=""></option>
                        {State.getStatesOfCountry(
                          this.state.productservicecustomer.country
                        ).map((s1) => (
                          <>
                            <option>{s1.name}</option>
                          </>
                        ))}
                      </Form.Select>
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3 " controlId="">
                    <Form.Label column sm="3">
                      PinCode
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="text"
                        name="pinCode"
                        maxlength="99"
                        value={this.state.productservicecustomer.pinCode}
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer className="bg-light">
              <Form.Group>
                <Button variant="primary" size="lg" type="submit">
                  Save
                </Button>
              </Form.Group>

              <Button variant="danger" size="lg" onClick={this.props.onHide}>
                Close
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </div>
    );
  }
}
